import { Link } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import React, {useState} from 'react'
import styles from './SideDrawer.module.css'
import { useLocation } from "@reach/router"


const MenuItem = () =>{
  // const [isActiveFirst, setIsActiveFirst] = useState(false);
  const [isActiveSecond, setIsActiveSecond] = useState(false);
  const { pathname } = useLocation();
  console.log(isActiveSecond)
  return (
    <ul>
      <li>
        <Link to="/about" activeClassName={styles.active}>Миний  тухай</Link>
      </li>  
      <li>
        <Link to="/license" activeClassName={styles.active}>Тусгай зөвшөөрөл</Link>
                    {/* <button className={pathname === "/license/" ? styles.dropbtn_closed : styles.dropbtn} 
                    activeClassName={styles.active} 
                    onClick={() => setIsActiveFirst(!isActiveFirst)}>
                      Тусгай зөвшөөрөл <span>&#11206;</span></button>            
                    <div className={isActiveFirst ? styles.subnav_content : styles.subnav_content_passive}>
                          <li>  <AnchorLink to="/license/#license-1" activeClassName={styles.subnav_active}>Аудит</AnchorLink></li>
                          <li>  <AnchorLink to="/license/#license-2" activeClassName={styles.subnav_active}>Сургалт</AnchorLink></li>
                          <li>  <AnchorLink to="/license/#license-3" activeClassName={styles.subnav_active}>ISO 50001 стандарт</AnchorLink></li>
                    </div> */}
      </li>
      <li>
        <Link to="/legal" activeClassName={styles.active}>Хууль,  журам</Link>
      </li> 
      <li>
                    <button className={pathname === "/services/energyaudit" || pathname === "/services/dah" 
                    || pathname === "/services/training" || pathname === "/services/iso50001" || pathname === "/services/research"  ? styles.dropbtn_closed : styles.dropbtn} 
                    activeClassName={styles.active} 
                    onClick={() => setIsActiveSecond(!isActiveSecond)}>Үйлчилгээ <span>&#11206;</span>
              
                    </button>            
                    <div className={isActiveSecond ? styles.subnav_content : styles.subnav_content_passive}>
                          <li>  <Link to="/services/energyaudit" activeClassName={styles.subnav_active}>Эрчим хүчний аудит</Link></li> 
                          <li>  <Link to="/services/dah" activeClassName={styles.subnav_active}>Дулаан алдагдлын хэмжилт</Link></li> 
                          <li>  <Link to="/services/training" activeClassName={styles.subnav_active} >Сургалт</Link></li> 
                          <li>  <Link to="/services/iso50001" activeClassName={styles.subnav_active} >ISO 50001 стандартын зөвлөх үйлчилгээ</Link></li> 
                          <li> <Link to="/services/research" activeClassName={styles.subnav_active} >Судалгаа, шинжилгээ</Link></li> 
                    </div>
      </li>
      <li>
        <Link to="/works" activeClassName={styles.active}>Хэрэгжүүлсэн төслүүд</Link>
      </li> 
      <li>
        <Link to="/photoalbum" activeClassName={styles.active}>Зургийн цомог</Link>
      </li> 
      <li>
        <Link to="/advisory" activeClassName={styles.active}>Зөвлөмж</Link>
      </li> 
      <li>
        <AnchorLink to="/#contact"> Холбоо  барих </AnchorLink>
      </li> 
    </ul>
  );
}

const SideDrawer = ({ isShown }) => {
  return (
    <nav className={isShown ? styles.side_drawer_open : styles.side_drawer}>
      <div className={styles.scroll}>
        <MenuItem/>
      </div>
    </nav>
  )
}

export default SideDrawer
